/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Feature_Support_CommunityInputs */

const en_tier_feature_support_community = /** @type {(inputs: Tier_Feature_Support_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community Support`)
};

const es_tier_feature_support_community = /** @type {(inputs: Tier_Feature_Support_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte comunitario`)
};

const fr_tier_feature_support_community = /** @type {(inputs: Tier_Feature_Support_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support Communautaire`)
};

const de_tier_feature_support_community = /** @type {(inputs: Tier_Feature_Support_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-Support`)
};

const ja_tier_feature_support_community = /** @type {(inputs: Tier_Feature_Support_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミュニティサポート`)
};

const zh_tier_feature_support_community = /** @type {(inputs: Tier_Feature_Support_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社区支持`)
};

const ar_tier_feature_support_community = /** @type {(inputs: Tier_Feature_Support_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعم المجتمع`)
};

const id_tier_feature_support_community = /** @type {(inputs: Tier_Feature_Support_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukungan Komunitas`)
};

const it_tier_feature_support_community = /** @type {(inputs: Tier_Feature_Support_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporto della Community`)
};

const ru_tier_feature_support_community = /** @type {(inputs: Tier_Feature_Support_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержка сообщества`)
};

const pt_tier_feature_support_community = /** @type {(inputs: Tier_Feature_Support_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporte da Comunidade`)
};

const ko_tier_feature_support_community = /** @type {(inputs: Tier_Feature_Support_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커뮤니티 지원`)
};

/**
* | output |
* | --- |
* | "Community Support" |
*
* @param {Tier_Feature_Support_CommunityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_feature_support_community = /** @type {((inputs?: Tier_Feature_Support_CommunityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Feature_Support_CommunityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_feature_support_community(inputs)
	if (locale === "es") return es_tier_feature_support_community(inputs)
	if (locale === "fr") return fr_tier_feature_support_community(inputs)
	if (locale === "de") return de_tier_feature_support_community(inputs)
	if (locale === "ja") return ja_tier_feature_support_community(inputs)
	if (locale === "zh") return zh_tier_feature_support_community(inputs)
	if (locale === "ar") return ar_tier_feature_support_community(inputs)
	if (locale === "id") return id_tier_feature_support_community(inputs)
	if (locale === "it") return it_tier_feature_support_community(inputs)
	if (locale === "ru") return ru_tier_feature_support_community(inputs)
	if (locale === "pt") return pt_tier_feature_support_community(inputs)
	return ko_tier_feature_support_community(inputs)
});